<div class="chips-wrapper" [formGroup]="form" (click-outside)="onClickOutside()">
  <div *ngFor="let chip of tags; let index = index" class="chip-wrapper">
    <span class="chip-text default-cursor"
          [tooltip]="getTooltipValue(chip)">
      {{getDisplayValue(chip)}}
    </span>
    <i (click)="remove(index)" aria-hidden="true" *ngIf="!readOnly" class="fa fa-light fa-times pointer chip-remover"></i>
  </div>
  <div class="chips-options-wrapper" *ngIf="!externalInput">
    <input [placeholder]="!readOnly  ? '+ ' + (placeholder | translate) : ''"
           type="text"
           class="form-control chip-placeholder no-border"
           formControlName="item"
           [attr.tabindex]="tabindex"
           (focus)="openOptions(true)"
           (keydown.enter)="addNewValue(extractValue($event.target))" #optionsSearch
    />
    <div *ngIf="withAutocomplete && hasOptions()" [ngClass]="{open: open}" class="chips-options">
      <ng-content></ng-content>
    </div>
  </div>
</div>
